module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/design/edit-c1ab3542816bf8e2c06a85f1191fed44.svg";